/**
 * Query-key factory for the action-plans slice. Mirrors the central
 * `queryKeys` convention (an `all` root per namespace so a subtree invalidates
 * in one call) but stays feature-local — the shared factory is frozen for the
 * wave.
 */
import { onBehalfKey } from "@/lib/api/on-behalf";

export const actionPlanKeys = {
  // Getter so partner-mode (on-behalf) data doesn't collide with the partner's
  // own cache; self-mode returns the identical key.
  get all() {
    return ["action-plans", ...onBehalfKey()] as const;
  },
  lists: () => [...actionPlanKeys.all, "list"] as const,
  detail: (id: string) => [...actionPlanKeys.all, "detail", id] as const,
  groups: () => [...actionPlanKeys.all, "stakeholder-groups"] as const,
  consultations: (planId?: string) =>
    [...actionPlanKeys.all, "consultations", planId ?? "all"] as const,
  prioritization: (planId: string) =>
    [...actionPlanKeys.all, "prioritization", planId] as const,
  history: (planId: string) =>
    [...actionPlanKeys.all, "history", planId] as const,
} as const;
